<template>
  <div class="speedup-choose">
    <b-loading class="loading" :is-full-page="false" :active.sync="isLoading"></b-loading>
    <b-button class="close" rounded size="is-small" @click="$emit('onClosed')">Close</b-button>

    <div class="columns is-multiline is-mobile">
      <div class="column is-12">
        <h1>Choose MiningXP Element</h1>
      </div>

      <div
        class="column is-2-desktop is-6-mobile"
        v-for="element in speedUpElements"
        :key="element.id"
      >
        <div @click="elementActiveId = element.id" :class="{isActive:element.id ==elementActiveId}">
          <ElementSmall :element="element" :ratio="element.myBalance" />
        </div>
      </div>
    </div>
    <div v-if="elementActiveId != undefined" class="columns is-mobile is-centered is-multiline">
      <div class="column is-half">
        <div class="plant-input columns is-multiline is-centered">
          <b-numberinput
            class="column"
            controls-position="compact"
            min="1"
            size="is-small"
            v-model="mulBonus"
          ></b-numberinput>
          <div class="column text-center">
            <div class="button is-primary is-small" @click="speedUp(mulBonus)">Speed up mining now!</div>
          </div>
        </div>
      </div>
      <div class="column is-12">
        <small
          class="preview-time"
        >* Using {{mulBonus}} tokens {{elements[elementActiveId].name}} (id:{{elements[elementActiveId].id}}) to reduce {{elements[elementActiveId].minutesBonus * mulBonus}} minutes</small>
      </div>
    </div>
  </div>
</template>

<script>
import ElementSmall from "@/components/ElementSmall";
import contract from "@/Utils/Contract.js";

export default {
  data() {
    return {
      isLoading: false,
      showInput: false,
      elementActiveId: undefined,
      mulBonus: 1
    };
  },
  props: {
    planId: Number
  },
  components: {
    ElementSmall
  },
  computed: {
    speedUpElements: function() {
      return contract.elements.filter(element => element.isSpeedUp);
    },
    elements: function() {
      return contract.elements;
    }
  },
  methods: {
    speedUp: async function(mulBonus) {
      try {
        this.isLoading = true;
        await contract.speedUp(this.planId, this.elementActiveId, mulBonus);
        this.isLoading = false;

        this.$toast.open({
          message: "Speed up mining is a success!",
          type: "is-success"
        });
      } catch (e) {
        this.isLoading = false;
        this.$toast.open({
          message: e.toString(),
          type: "is-danger"
        });
      }
    }
  }
};
</script>

<style>
.speedup-choose {
  margin: 10px;
  text-align: center;
}
.speedup-choose .isActive {
  box-shadow: rgba(31, 42, 75, 0.3) 0px 20px 40px;
  border-radius: 10px;
  transform: scale(1.05);
}
.preview-time {
  font-size: small;
  color: red;
}
.close {
  position: absolute;
  right: 5px;
  top: 5px;
}
</style>